import { render, staticRenderFns } from "./UserNameField.vue?vue&type=template&id=2d99bf40"
import script from "./UserNameField.vue?vue&type=script&lang=js"
export * from "./UserNameField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports